<template>
  <div class="shop-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="水木商城" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div class="product-category-list">
      <div v-if="categorySelected != 'all'" @click = "selectCategory('all')" class="product-category-item">全部</div>
      <div v-if="categorySelected == 'all'" class="product-category-item category-selected">全部</div>
      <div v-for="(category,index) in productCategoryList" @click = "selectCategory(index,category.id)" class="product-category-item" :class="{'category-selected': categorySelected == index}">{{category.name}}</div>
    </div>
    <div class="shop-tab-part">
      <div v-if="tabSelected == '0'" class="mine-middle-item tab-selected">销量</div>
      <div v-if="tabSelected != '0'" @click = "changeTab('0')" class="mine-middle-item">销量</div>
      <div  v-if="tabSelected == '1'" class="mine-middle-item tab-selected">好评</div>
      <div v-if="tabSelected != '1'" @click = "changeTab('1')" class="mine-middle-item">好评</div>
      <div  v-if="tabSelected == '2'" class="mine-middle-item tab-selected">热门</div>
      <div v-if="tabSelected != '2'" @click = "changeTab('2')" class="mine-middle-item">热门</div>
    </div>
    <mt-loadmore style="font-size:0.24rem;color: #aaaaaa;position: relative" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" :auto-fill ='autoFill' bottomLoadingText = '加载更多' ref="loadmore">
      <div class="shop-list">
        <div v-if="shopList.length>0" class="shop-item general-box-shadow" v-for="shop in shopList" @click="toShopDetail(shop.id,shop.name,shop.intro)">
          <img class="shop-logo" :src="imgUrl+shop.logo">
          <div class="shop-info">
            <div class="shop-name">{{shop.name}}</div>
            <div class="shop-trade-info">
              <div class="item">
                <span class="label">订单数</span>
                <span>{{shop.orderNum}}</span>
              </div>
              <div class="item">
                <span class="label">交易数 </span>
                <span>{{shop.tradeNum}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!isHaveShop" class="black-page">
          <img src="../../assets/icon-no-img.png">
          <div class="tip">暂无相关店铺!</div>
        </div>
      </div>
    </mt-loadmore>
  </div>
</template>

<script>
  import {Toast } from 'mint-ui'
  import Header from '../../components/header/Header'
  import {imgUrl,shareIcon} from "../../config";
  import ProductService from '../../service/product/ProductService'
  import ShopService from '../../service/shop/ShopService'
  import shareService from '../../service/share/ShareService'

  export default {
    name: 'ShopList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        categorySelected:'all',
        categoryId:'',
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        tabSelected:'0',
        sort:'',
        productCategoryList:[],
        shopList:[],
        allLoaded: false,
        pageNo:1,
        autoFill:false,
        keyword:'',
        isWechatBrowser:this.$verfyBrowserType(),
        isHaveShop:false
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.loadProductCategoryList();
      this.loadShopList();
      this.initWechatShare();
    },
    methods: {
      async loadProductCategoryList(){
        let {code,msg,data} = await ProductService.categoryList();
        if(code == '0'){
          this.productCategoryList = data.categories;
        }else {
          Toast(msg);
        }
      },
      async loadShopList(onCancel = function(){}){
        if(this.pageNo == 1){
          this.shopList = [];
        }
        let {code,msg,data} = await ShopService.list(this.sort,this.categoryId,this.keyword,this.pageNo);
        if(code == '0'){
          for(let shop of data.result){
            if(shop.name.length>12){
              shop.name = shop.name.substring(0,12)+'...'
            }
            this.shopList.push(shop)
          }
          if(this.shopList.length !=0){
            this.isHaveShop = true
          } else {
            this.isHaveShop = false
          }
          this.allLoaded = this.pageNo < data.pageSize? false:true;
          onCancel();
        }else {
          Toast(msg);
        }
      },
      changeTab(tab){
        this.tabSelected = tab;
        if(tab == '0'){
          this.sort = ''
        }else if(tab == '1'){
          this.sort = 'good_evaluate_ratio'
        }else if(tab == '2'){
          this.sort = 'popularity'
        }
        this.pageNo = 1;
        this.loadShopList();
      },
      selectCategory(index,categoryId){
        this.categorySelected = index;
        this.categoryId = categoryId;
        this.pageNo = 1;
        this.loadShopList();
      },
      loadBottom(){
        this.pageNo++;
        this.loadShopList(()=>{
          this.$refs.loadmore.onBottomLoaded();
        });
      },
      //跳转店铺详情
      toShopDetail(id,shopName,shopIntro){
        this.$router.push({name: 'ShopDetail', query: {shopId:id,shopName,shopIntro}})
      },
      async initWechatShare(){
        let title = "水木商城";// 分享标题
        let desc = "汇集靠谱的优质建材，省心有品质，还有水木家居商城优惠补贴哦！"; // 分享描述
        let link = window.location.href; // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      },
    }
  }
</script>
<style lang="scss">
  .clear-header{
    margin-top: -1rem;
  }
  .shop-list-page{
    background-color: white;
    font-size: 0.32rem;
    color: #191818;
    overflow: scroll;
    .product-category-list{
      display: flex;
      flex-wrap: nowrap;
      height: 0.84rem;
      padding-top: 0.2rem;
      line-height: 0.84rem;
      margin-left: 0.3rem;
      overflow-x: scroll;
      border-bottom: solid 1px #e0dedc;
      color: #939599;
      .product-category-item{
        flex-shrink: 0;
        margin-right: 0.3rem;
      }
      .category-selected{
        font-size: 0.36rem;
        color: #191818;
        font-weight: bold;
      }
    }
    .general-box-shadow{
      border-radius: 0.08rem;
      box-shadow: 0rem 0.02rem 0.07rem 0rem
      rgba(0, 0, 0, 0.1);
    }
    .shop-tab-part{
      display: flex;
      height: 0.7rem;
      line-height: 0.7rem;
      margin-left: 0.3rem;
      margin-bottom: 0.11rem;
      font-weight: bold;
      .mine-middle-item{
        margin-right: 0.29rem;
      }
      .tab-selected{
        color: #feac00;
      }
    }
    .shop-list{
      padding-left: 0.3rem;
      font-size: 0.36rem;
      color: #191818;
      .shop-item{
        display: flex;
        width: 6.9rem;
        height: 1.71rem;
        margin-bottom: 0.2rem;
        .shop-logo{
          width: 1.3rem;
          height: 1.3rem;
          margin: 0.2rem;
          border-radius: 0.06rem
        }
        .shop-info{
          padding-left: 0.12rem;
          .shop-name{
            padding: 0.2rem 0 0.25rem;
          }
          .shop-trade-info{
            display: flex;
            font-size: 0.26rem;
            .item{
              margin-right: 0.3rem;
              padding: 0.06rem 0.3rem;
              background-color: #e0dedc;
              border-radius: 20px;
              .label{
                font-size: 0.25rem;
                padding-right: 0.05rem;
              }
            }
          }
        }
      }
    }
  }
</style>
